import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Wrap from './Wrap';

const HeadImage = '/DEPI_Header_Haende.jpg';

const useStyles = makeStyles(theme => ({
  background: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: 'calc(100vh - 200px)',
    position: 'relative',
    maxHeight: 1000,
    // '&:before': {
    //   content: '""',
    //   width: '100%',
    //   height: '100%',
    //   position: 'absolute',
    //   top: 0,
    //   left: 0,
    //   background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 50%, rgba(0,0,0,0.5) 100%)',
    // },
  },
}));

const WelcomeSection = () => {
  const classes = useStyles();
  return (
    <Wrap
      maxWidth={900}
      className={classes.background}
      style={{ backgroundImage: `url(${HeadImage})` }}
    >
      <Box
        display="flex"
        height="100%"
        flexDirection="column"
        justifyContent="flex-end"
      >
        <Typography
          color="secondary"
          align="center"
          variant="h2"
          gutterBottom
          data-shadow
        >
          <b>Willkommen beim Deutschen Pelletinstitut.</b>
        </Typography>
        <Typography color="secondary" align="center" variant="h6" data-shadow>
          Hier erfahren Sie alles rund um das Thema Holzpellets.
        </Typography>
      </Box>
    </Wrap>
  );
};

export default WelcomeSection;
